module.exports = __webpack_public_path__ + "img/index_mcont_fur.81e24952.png";